<template>
  <div>
    <hanatour-header :hanatour-host="hanatourHost"></hanatour-header>
    <div id="app-container">
      <div class="contents">
        <router-view />
      </div>
      <transition name="fade">
        <div class="footer-stick" v-if="scrollTop>90">
          <button class="gotoTop" ref="gotoTop" @click="gotoTop">
            <i class="icon arrow-page-top"></i>
            <span class="blind">Top</span>
          </button>
        </div>
      </transition>
    </div>
    <hanatour-footer :hanatour-host="hanatourHost"></hanatour-footer>
  </div>
</template>

<script>
import HanatourHeader from '@/views/components/hanatour-header';
import HanatourFooter from '@/views/components/hanatour-footer';
import { hosts } from '~/config';

export default {
  title: 'Default Layout',
  components: {
    HanatourHeader,
    HanatourFooter,
  },
  data() {
    return {
      scrollTop: 0,
    };
  },
  computed: {
    hanatourHost() {
      return hosts.hanatour;
    },
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    gotoTop() {
      window.scrollTo({
        behavior: 'smooth',
        top: 0
      });
    },
    handleScroll() {
      this.scrollTop = this.getScrollTop();
    },
  },
}
</script>

<style scoped lang="scss">
div {
  transition: padding-top $duration-slow ease-in-out;
}
#app-container {
  .contents {
    min-height: calc(100vh - 56px - 366px);
  }

  .footer-stick {
    position: fixed;
    width: 100%;
    min-width: 1280px;
    bottom: 65px;
    z-index: 9;

    .gotoTop {
      width: 50px;
      height: 50px;
      right: 40px;
      margin-top: -25px;
      background-color: $white;
      border-radius: 25px;
      position: absolute;
      box-shadow: 4px 7px 21px 0 rgba(0, 0, 0, 0.1);
      color: $primary-color;
      font-size: 10px;
    }

    &.fade-enter-active, &.fade-leave-active {
      transition: opacity .5s;
    }

    &.fade-enter, &.fade-leave-to {
      opacity: 0;
    }
  }
}
</style>
